<template>
    <b-modal ref="modal" centered class="modal-removal">
        <template slot="modal-header">
            <h1>{{ Translations.sections.dayTemplates.removal.title }} : {{ (dtData ||{}).name ||""}}</h1>
        </template>
        <template>
            <WaitingBlock v-if="modalState.isLoadingDT">
            </WaitingBlock>
            <div class="modal-content-container">
                <div v-if="!isRemovable && dtData" class="table-container">
                    <h4>
                        Day Template not removable
                    </h4>
                    <div class="removal-warning-card" v-if="((dtData||{}).schedules||[]).length > 0">
                        <i :class="['fas', 'fa-exclamation-circle']"></i>
                        {{ dtData.schedules.length || 0 }} scheduled dates
                    </div>
                </div>
                <div v-else>
                    <h2 class="modal-content-title">{{Translations.sections.dayTemplates.removal.text}}</h2>
                </div>
                <div v-if="error" class="modal-content-row">
                    <div class="modal-content-col modal-content-col--full">
                        <span class="text-danger">{{ error === 'DAYTEMPLATE_NOT_ELLIGIBLE_TO_REMOVAL' ? 'This day template can\'t be deleted' : 'Oops, an error occurs while deleting the day template'}}</span>
                    </div>
                </div>
            </div>
        </template>
        <template slot="modal-footer">
            <Button :empty="true" class="close-popup" @click.prevent="hide">{{ Translations.buttons.cancel }}</Button>
            <div class="modal-footer-right">
                <div v-if="modalState.isRemoving" class="m-loader"></div>
                <Button :empty="false" :disabled="modalState.isRemoving" class="validate" v-if="isRemovable" @click.prevent="deleteDT">{{ Translations.buttons.doDeleteDayTemplate }} </Button>
                <Button :empty="false" class="validate" v-else="!isRemovable" @click.prevent="hide()">{{ Translations.buttons.close }} </Button>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import Button from'@/components/common/Button';
    import Bootstrap from 'bootstrap-vue';
    import store from '@/store';
    import Translations from '@/store/translations';
    import EventBus from '@/eventbus';
    import { HTTP } from '@/utils/http';
    import Apis from '@/apis/index'
    import { mapState } from 'vuex';
    import WaitingBlock from'@/components/common/WaitingBlock';

    export default {
        name: "DayTemplateRemovalCard",
        store,
        components: { Bootstrap, Button, WaitingBlock },
        computed: {
            ...mapState(['currentStation']),
            Translations: function () { return Translations; },
            isRemovable() {
                console.log("isRemovable", this.modalState.hasLoadingError, this.dayTemplateUid, this.dtData, (this.dtData || {}).schedules)
                return !this.modalState.hasLoadingError
                    && this.dtData != null
                    && this.dtData.schedules != null
                    && this.dtData.schedules.length == 0;
            },
        },

        props: ['stationUid', 'dayTemplateUid', 'displayData'],

        watch: {
            'dayTemplateUid': function (to, from) {
                console.log("watch");
                this.resetData();
                this.loadStatistics();
                // Reload Stats
            }
        },
        create() { console.log("created") },
        mounted() {
            console.log("mounted"),
                this.show();
        },
        data() {
            return {
                modalState: {
                    show: true,
                    visible: true,
                    isRemoving: false,
                    isLoadingDT: false,
                    isDeletingDT: false,
                    hasDeleteDT: false,
                    hasLoadingError: false,
                },
                error: null,
                dtData: null
            }
        },
        methods: {
            show() {
                console.log("show")
                this.resetData();
                this.loadStatistics();
                this.$refs.modal.show();
            },
            hide() {
                this.resetData();
                this.$refs.modal.hide();
            },
            resetData() {
                console.log("resetData");
                this.error = null;
                this.dtData = null;
                this.modalState.isRemoving = false;
                this.modalState.isLoadingDT = false;
                this.modalState.isDeletingDT = this.modalState.hasDeleteError = this.modalState.hasLoadingError = false;
                this.deleteResponse = this.dtData = null;
            },
            async loadStatistics() {
                console.log("Load statistics")
                this.resetData();
                try {
                    console.log(this.currentStation, this.dayTemplateUid)

                    if (this.currentStation != null && this.dayTemplateUid) {
                        this.modalState.isLoadingDT = true;
                        HTTP.post(Apis.daytemplates.removalData, { stationUid: this.currentStation.uid, dayTemplateUid: this.dayTemplateUid })
                            .then(this.onDataLoaded, this.onDataLoadError)
                            .then(this.onDataLoadComplete);
                    }
                    else {
                        this.modalState.isLoadingDT = false;
                    }
                } catch (e) {
                    alert(e);
                    this.modalState.isLoadingDT = false;
                }
            },
            onDataLoaded(response) {
                var data = response.data.dataItem;
                //if (data != null) {
                //    data = data.sort(function (a, b) { return (a.statistics.dayTemplateCount || 0) - (b.statistics.dayTemplateCount || 0) });
                //}
                this.dtData = data;
            },
            onDataLoadError(error) { this.modalState.hasLoadingError = true; this.deleteResponse = error.response.data; },
            onDataLoadComplete(response) { this.modalState.isLoadingDT = false; console.log("onDataLoadComplete", this.modalState.isLoadingDT) },

            async deleteDT() {
                console.log("DELETE DT");
                this.error = null;
                this.modalState.isRemoving = true;

                try {
                    const response = await HTTP.post(Apis.daytemplates.remove, {
                        stationUid: this.stationUid,
                        daytemplateUid: this.dayTemplateUid
                    });
                    console.log(response);
                    this.modalState.isRemoving = false;
                    EventBus.$emit('onDayTemplateDeleted', this.dayTemplateUid);
                    this.hide();
                } catch (e) {
                    console.log(e);
                    const response = e.response.data;

                    if (response && response.errors && response.errors.length > 0) {
                        if (response.errors[0].message === 'DAYTEMPLATE_NOT_ELLIGIBLE_TO_REMOVAL') {
                            this.error = response.errors[0].message;
                        } else {
                            this.error = e.message;
                        }
                    } else {
                        this.error = e.message;
                    }
                }
                this.modalState.isRemoving = false;
            }
        }
    }
</script>

<style>
</style>
